import React from 'react';
import { Button, makeStyles, withStyles, ButtonProps } from '@material-ui/core';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  button: {
    boxShadow: '0 2px 2px 0 rgba(0,0,0,0.30)',
    borderRadius: '2px',
    textAlign: 'center',
    width: '100%',
    height: '48px',
    marginTop: '16px',
  },
}));

/** タクシー・ハイヤー予約画面の予約ボタンのコンポーネント。 */
export const ButtonToSubmit: React.FC<ButtonProps> = (props: ButtonProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  /** 背景色を黄色、ラベル色を黒にしたボタンのコンポーネント。 */
  const YellowButton = withStyles({
    root: {
      backgroundColor: "#FDB50A",
    },
    label: {
      color: "#0f0f0f",
    },
  })(Button);
  return (
    <YellowButton
      size="large"
      variant="contained"
      className={classes.button}
      endIcon={<ArrowForwardIosIcon/>}
      disabled={props.disabled}
      {...props}
    >
      {t('taxi:process_reservation_button')}
    </YellowButton>
  );
}
